<template>
  <div class="realalarm-container" :class="'isMore' + isMore">
    <div class="top-map" ref="topMap">
      <!-- 与实时监控一致：工具条叠在地图内上方；本页无搜索框 -->
      <div class="maps-change">
        <el-radio-group v-model="mapType" size="mini" @change="changeMap">
          <el-radio-button label="tdt">{{ $t('operate.name74') }}</el-radio-button>
          <el-radio-button label="google">{{ $t('operate.name73') }}</el-radio-button>
        </el-radio-group>
      </div>
      <div v-show="mapType === 'tdt'" class="map-item">
        <div id="alarmMapDiv" class="map"></div>
      </div>
      <GmapMap
        v-if="mapType === 'google'"
        :center="mapCenter"
        :zoom="mapZoom"
        :options="googleMapOptions"
        class="map-item"
        ref="mapRef"
        @click="infoWinOpenGoogle = false"
      >
        <gmap-info-window
          :options="infoOptionsGoogle"
          :position="infoWindowPosGoogle"
          :opened="infoWinOpenGoogle"
          @closeclick="infoWinOpenGoogle = false"
        />
        <gmap-marker
          v-for="(item, index) in googleMarkers"
          :key="item.ebikeId || index"
          :position="{ lng: Number(item.lng), lat: Number(item.lat) }"
          :icon="item.status === 0 ? bikeredIcon : bikeblueIcon"
          :clickable="true"
          @click="openGoogleInfoWindow(item, index)"
        />
      </GmapMap>
    </div>
    <div class="bottom-list">
      <el-table :data="warnList" height="calc(100% - 10px)" :highlight-current-row="true" @row-click="clickMarker">
        <el-table-column :label="$t('finance.name40')" align="center" prop="tenantName" />
        <el-table-column :label="$t('bike.name278')" align="center" prop="ebikeCode" />
        <el-table-column :label="$t('finance.name28')" align="center" prop="ebikeId" />
        <el-table-column :label="$t('bike.name43')" align="center" prop="controllerVersion" />
        <el-table-column :label="$t('bike.name106')" align="center" prop="meterVersion" />
        <el-table-column :label="$t('bike.name107')" align="center" prop="iotVersionNo" />
        <el-table-column :label="$t('home.name26')" align="center" prop="soc" />
        <el-table-column :label="$t('bike.name139')" align="center" prop="batteryTemp">
          <template slot-scope="scope">
            {{ formatBatteryTempDisplay(scope.row.batteryTemp, scope.row.batteryTemperatureShowDeviation) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('bike.name375')" align="center" prop="createTime" />
        <el-table-column :label="$t('home.name27')" align="center" prop="status">
          <template slot-scope="scope">
            {{[$t('bike.name113'), $t('bike.name228'), $t('home.name30')][scope.row.status]}}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <AppDialog size="lg" width="80%" extra-class="histor-dialog" :title="$t('bike.name489')" :visible.sync="historicalTrajectoryDialog" v-if="historicalTrajectoryDialog" :before-close="close">
      <HistoricalTrajectory></HistoricalTrajectory>
    </AppDialog>
  </div>
</template>
<script>
import customMarker from '@/assets/bike.png'
import { mapGetters } from 'vuex'
import { toMapLngLat } from '@/utils/mapCoords'
import HistoricalTrajectory from '@/components/HistoricalTrajectory'
import AppDialog from '@/components/AppDialog/index.vue'
import { formatBatteryTempDisplay } from '@/utils/batteryTempDisplay.js'
import { escapeHtml } from '@/utils/htmlEscape'
import { defaultMapType } from '@/config/flavor'

const DEFAULT_MAP_CENTER = { lng: 116.4074, lat: 39.9042 }

function hasValidCoord (item) {
  const lng = Number(item?.lng)
  const lat = Number(item?.lat)
  return Number.isFinite(lng) && Number.isFinite(lat)
}

export default {
  computed: {
    ...mapGetters(['userinfo']),
    googleMarkers () {
      return this.points.filter((item) => hasValidCoord(item))
    },
  },
  props: {
    alarmList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    HistoricalTrajectory,
    AppDialog,
  },
  data () {
    return {
      historicalTrajectoryDialog: false,
      curPoint: '',
      // 缺省来自 flavor：国内 tdt / 海外 google（含海外测试服）；用户仍可切换
      mapType: defaultMapType,
      mapCenter: { ...DEFAULT_MAP_CENTER },
      customMarker: customMarker,
      mapZoom: 10,
      googleMapOptions: {
        mapTypeControl: false,
        streetViewControl: true,
        fullscreenControl: true,
      },
      infoWindowPosGoogle: null,
      infoWinOpenGoogle: false,
      currentGoogleMarkerIdx: null,
      infoOptionsGoogle: {
        content: '',
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      bikeblueIcon: {
        url: require('@/assets/bikeblue.png'),
        size: { width: 50, height: 30 },
        scaledSize: { width: 50, height: 30 },
      },
      bikeredIcon: {
        url: require('@/assets/bikered.png'),
        size: { width: 50, height: 30 },
        scaledSize: { width: 50, height: 30 },
      },
      points: [],
      isMore: 0,
      warnList: [],
      mapTD: null,
      T: null,
      tdtMarkers: []
    }
  },
  watch: {
    alarmList: {
      handler () {
        this.initData()
      },
      deep: true
    }
  },
  mounted () {
    this.initData()
  },
  beforeDestroy () {
    this.destroyTdtMap()
  },
  methods: {
    formatBatteryTempDisplay,
    showEBikeDetails () {
      this.historicalTrajectoryDialog = true
    },
    close () {
      this.historicalTrajectoryDialog = false
    },
    normalizeAlarmList (list) {
      return (list || []).map((item) => {
        const row = { ...item }
        Object.keys(row).forEach((k) => {
          if (
            k !== 'lng' && k !== 'lat' && k !== 'status' && k !== 'lockStatus' &&
            k !== 'batteryTemp' && k !== 'soc' && k !== 'batteryTemperatureShowDeviation' &&
            k !== 'keepaliveTime' && k !== 'keepliveTime' && k !== 'createTime'
          ) {
            row[k] = row[k] || '--'
          }
        })
        return row
      })
    },
    closeGoogleInfoWindow () {
      this.infoWinOpenGoogle = false
      this.currentGoogleMarkerIdx = null
    },
    initData () {
      this.closeGoogleInfoWindow()
      this.warnList = this.normalizeAlarmList(this.alarmList)
      if (this.mapType === 'tdt') {
        this.$nextTick(() => this.initTdtMap(this.warnList))
      } else {
        this.initGoogleMap(this.warnList)
      }
    },
    destroyTdtMap () {
      if (this.mapTD && this.tdtMarkers.length) {
        this.tdtMarkers.forEach((marker) => {
          try {
            this.mapTD.removeOverLay(marker)
          } catch (e) { /* ignore */ }
        })
      }
      this.tdtMarkers = []
      this.mapTD = null
      this.T = null
      const container = document.getElementById('alarmMapDiv')
      if (container) {
        container.innerHTML = ''
      }
    },
    initTdtMap (dataList) {
      if (!window.T) return
      this.destroyTdtMap()

      const mappablePoints = (dataList || []).filter(hasValidCoord)
      this.points = mappablePoints

      this.T = window.T
      const mapTD = new this.T.Map('alarmMapDiv', {
        attributionControl: true,
        inertia: true
      })
      const center = mappablePoints.length
        ? { lng: Number(mappablePoints[0].lng), lat: Number(mappablePoints[0].lat) }
        : DEFAULT_MAP_CENTER
      mapTD.centerAndZoom(new this.T.LngLat(center.lng, center.lat), mappablePoints.length ? 14 : 5)
      mapTD.addControl(new this.T.Control.Zoom())
      this.mapTD = mapTD

      mappablePoints.forEach((item) => {
        const iconUrl = item.status === 0
          ? require('@/assets/bikered.png')
          : require('@/assets/bikeblue.png')
        const marker = new this.T.Marker(
          new this.T.LngLat(Number(item.lng), Number(item.lat)),
          {
            icon: new this.T.Icon({
              iconUrl,
              iconSize: new this.T.Point(50, 30)
            })
          }
        )
        this.mapTD.addOverLay(marker)
        this.tdtMarkers.push(marker)
        this.addClickHandler(item, marker, this.T, this.mapTD, this)
      })
    },
    addClickHandler (item, marker, T, mapTD, that) {
      marker.addEventListener('click', function (e) {
        const sContent = that.buildInfoContent(item)
        const point = e.lnglat
        const markerInfoWin = new T.InfoWindow(sContent, { offset: new T.Point(0, 0) })
        mapTD.openInfoWindow(markerInfoWin, point)
      })
    },
    openTdtMarker (item) {
      if (!this.mapTD || !this.T || !hasValidCoord(item)) return
      const point = new this.T.LngLat(Number(item.lng), Number(item.lat))
      this.mapTD.panTo(point)
      this.mapTD.setZoom(14)
      const markerInfoWin = new this.T.InfoWindow(
        this.buildInfoContent(item),
        { offset: new this.T.Point(0, 0) }
      )
      this.mapTD.openInfoWindow(markerInfoWin, point)
    },
    buildInfoContent (item) {
      const keepaliveTime = item.keepaliveTime || item.keepliveTime || '--'
      const speed = item.speed === '--' ? '--' : Number(item.speed / 10).toFixed(1)
      const batteryTemp = formatBatteryTempDisplay(item.batteryTemp, item.batteryTemperatureShowDeviation)
      return '<div><span>' + this.$t('bike.name65') + '</span>' + escapeHtml(item.ebikeId || '--') + '</div>' +
        '<div><span>' + this.$t('bike.name295') + '</span>' + escapeHtml(item.ebikeCode || '--') + '</div>' +
        '<div><span>' + this.$t('bike.name492') + '</span>' + escapeHtml(item.mac || '--') + '</div>' +
        '<div><span>' + this.$t('bike.name493') + '</span>' + escapeHtml(item.tenantName || '--') + '</div>' +
        '<div><span>' + this.$t('bike.name168') + '</span>' + escapeHtml(keepaliveTime) + '</div>' +
        '<div><span>' + this.$t('bike.name171') + '</span>' + escapeHtml(item.alt || '--') + '</div>' +
        '<div><span>' + this.$t('bike.name216') + '</span>' + escapeHtml(speed) + '</div>' +
        '<div><span>' + this.$t('bike.name217') + '</span>' + escapeHtml(item.soc != null ? item.soc : '--') + '</div>' +
        '<div><span>' + this.$t('bike.name494') + '</span>' + escapeHtml([this.$t('home.name28'), this.$t('home.name29')][item.lockStatus]) + '</div>' +
        '<div><span>' + this.$t('bike.name35') + '</span>' + escapeHtml([this.$t('bike.name113'), this.$t('bike.name228'), this.$t('home.name30')][item.status]) + '</div>' +
        '<div><span>' + this.$t('bike.name220') + '</span>' + escapeHtml(batteryTemp) + '</div>'
    },
    initGoogleMap (dataList) {
      this.points = (dataList || [])
        .filter(hasValidCoord)
        .map((item) => {
          const row = { ...item }
          const pt = toMapLngLat(Number(row.lng), Number(row.lat), 'google')
          if (!pt) return null
          row.lng = pt.lng
          row.lat = pt.lat
          row.infoText = this.buildInfoContent(row)
          return row
        })
        .filter(Boolean)
      if (this.points.length) {
        this.mapCenter = { lng: this.points[0].lng, lat: this.points[0].lat }
        this.mapZoom = 14
      } else {
        this.mapCenter = { ...DEFAULT_MAP_CENTER }
        this.mapZoom = 5
      }
    },
    changeMap () {
      this.closeGoogleInfoWindow()
      this.initData()
    },
    openGoogleInfoWindow (item, idx) {
      if (!item || !hasValidCoord(item)) return
      this.infoWindowPosGoogle = { lng: Number(item.lng), lat: Number(item.lat) }
      this.infoOptionsGoogle = {
        ...this.infoOptionsGoogle,
        content: item.infoText || this.buildInfoContent(item),
      }
      this.mapCenter = { lng: Number(item.lng), lat: Number(item.lat) }
      this.mapZoom = 14
      if (this.currentGoogleMarkerIdx === idx) {
        this.infoWinOpenGoogle = !this.infoWinOpenGoogle
      } else {
        this.infoWinOpenGoogle = true
        this.currentGoogleMarkerIdx = idx
      }
    },
    clickMarker (item) {
      if (!hasValidCoord(item)) return
      if (this.mapType === 'google') {
        const mapItem = this.points.find((p) => p.ebikeId === item.ebikeId)
        if (!mapItem || !hasValidCoord(mapItem)) return
        const idx = this.googleMarkers.findIndex((p) => p.ebikeId === mapItem.ebikeId)
        this.openGoogleInfoWindow(mapItem, idx >= 0 ? idx : 0)
        return
      }
      this.openTdtMarker(item)
    }
  }
}
</script>
<style lang="scss">
.histor-dialog.el-dialog {
  margin-top: 5vh !important;
}
</style>

<style lang="scss" scoped>
.realalarm-container {
  height: 80vh;
  box-sizing: border-box;
  overflow: hidden;

  .top-map {
    height: 60%;
    position: relative;

    .maps-change {
      position: absolute;
      top: 10px;
      left: 50px;
      z-index: 9999;
    }

    .map-item {
      width: 100%;
      height: 100%;
      position: relative;

      .map {
        width: 100%;
        height: 100%;
      }
    }
  }

  .bottom-list {
    height: 40%;
    .el-table {
      margin-top: 0 !important;
    }
  }

  &.isMore1 {
    .top-map {
      height: calc(100% - 15px);
    }
    .bottom-list {
      height: 0;
    }
  }
  &.isMore2 {
    .top-map {
      height: 0;
    }
    .bottom-list {
      height: 100%;
    }
  }
}
</style>
